import { ChildType, NodeVariableTypes } from "@common/types/tree-types";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const strategyTransferredIsNotDraggable = (
  node: ChildType | NodeVariableTypes,
) => {
  return node.selected && !node.transferred;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const strategyTransferredIsDraggable = (
  node: ChildType | NodeVariableTypes,
) => {
  return node.selected || node.transferred;
};

const DEFAULT_STRATEGY = strategyTransferredIsNotDraggable;
// const DEFAULT_STRATEGY = strategyTransferredIsDraggable;

export const isDraggable = (
  node: ChildType | NodeVariableTypes,
  strategy?: (node: ChildType | NodeVariableTypes) => boolean,
) => {
  const selectedStrategy = strategy || DEFAULT_STRATEGY; // Use provided strategy or default

  return selectedStrategy(node);
};
